var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWhyChoose1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_322_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.96415 12.9976C10.2187 12.9976 12.857 10.3593 12.857 7.10477C12.857 3.85024 10.2187 1.21191 6.96415 1.21191C3.70961 1.21191 1.07129 3.85024 1.07129 7.10477C1.07129 10.3593 3.70961 12.9976 6.96415 12.9976Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0354 12.9976C26.29 12.9976 28.9283 10.3593 28.9283 7.10477C28.9283 3.85024 26.29 1.21191 23.0354 1.21191C19.7809 1.21191 17.1426 3.85024 17.1426 7.10477C17.1426 10.3593 19.7809 12.9976 23.0354 12.9976Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96415 29.0689C10.2187 29.0689 12.857 26.4306 12.857 23.1761C12.857 19.9215 10.2187 17.2832 6.96415 17.2832C3.70961 17.2832 1.07129 19.9215 1.07129 23.1761C1.07129 26.4306 3.70961 29.0689 6.96415 29.0689Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0354 29.0689C26.29 29.0689 28.9283 26.4306 28.9283 23.1761C28.9283 19.9215 26.29 17.2832 23.0354 17.2832C19.7809 17.2832 17.1426 19.9215 17.1426 23.1761C17.1426 26.4306 19.7809 29.0689 23.0354 29.0689Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_99"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.140625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhyChoose1);
export default __webpack_public_path__ + "static/media/icon-why-choose-1.0d6e64b5baab4de28960e1573bb28c2a.svg";
export { ForwardRef as ReactComponent };